<template>
  <div class="header">
    <header class="bdb-header">
      <div class="header_inner">
        <div
          class="hd-logo"
          :class="{ 'is-show': !headerLogo }"
          @click="$router.go(-1)"
        >
          <i class="icon icon-hd-arrow" />
        </div>
        <div class="hd-logo2-grp" :class="{ 'is-show': headerBadabaLogo }">
          <div class="hd-logo2">
            <img
              src="@/assets/images/logo/logo_blue2.webp"
              alt="로고"
              class="img"
            />
          </div>
        </div>
        <p class="hd-ttl f-s f-bk">
          {{ hdTitle }}
        </p>

        <button
          class="btn btn-hamburger"
          :class="{ 'is-show': !headerHam }"
          @click="visibleSideNav = !visibleSideNav"
        >
          <i class="icon icon-hamburger" />
        </button>
      </div>
    </header>

    <layoutSideNavStaff :visible-side-nav.sync="visibleSideNav" />
  </div>
</template>

<script>
export default {
  name: "LayoutHeaderStaff",
  props: {
    headerLogo: {
      type: Boolean,
      default: true,
    },
    headerBadabaLogo: {
      type: Boolean,
      default: false,
    },
    headerHam: {
      type: Boolean,
      default: true,
    },
    hdTitle: {
      type: String,
      default: "", // 해당 페이지의 header title 값
    },
  },
  data() {
    return {
      visibleSideNav: false,
    };
  },
};
</script>
